import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FullLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M9 4H7c-1.414 0-2.121 0-2.56.44C4 4.878 4 5.585 4 7v2M9 20H7c-1.414 0-2.121 0-2.56-.44C4 19.122 4 18.415 4 17v-2M15 4h2c1.414 0 2.121 0 2.56.44C20 4.878 20 5.585 20 7v2M15 20h2c1.414 0 2.121 0 2.56-.44.44-.439.44-1.146.44-2.56v-2" })));
}
const FullLight = forwardRef(_FullLight);
export { FullLight };
